export default __webpack_public_path__ + "static/media/Banner_CONOCELES.48ac37f3.png";